'use strict';

require('../../style/index.less');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/lib/grid/style/index.js
// module id = 427
// module chunks = 1